module.exports = __webpack_public_path__ + "img/straight_line2_icon.04918201.svg";